import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { LogIn, User } from 'react-feather'
import man from '../../assets/images/dashboard/profile.png'

import { LI, UL, Image, P } from '../../AbstractElements'
import CustomizerContext from '../../_helper/Customizer'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { Account, Admin, LogOut } from '../../Constant'

const UserHeader = () => {
	const history = useNavigate()
	const [profile, setProfile] = useState('')
	const { layoutURL } = useContext(CustomizerContext)
	const { user, logout } = useAuth()
	const authenticated = JSON.parse(localStorage.getItem('authenticated') || 'false')
	const auth0_profile = JSON.parse(localStorage.getItem('auth0_profile') || 'null')

	useEffect(() => {
		setProfile(localStorage.getItem('profileURL') || man)
	}, [])

	const Logout = () => {
		logout()
		history(`${process.env.PUBLIC_URL}/login`)
	}

	const UserMenuRedirect = (redirect) => {
		history(redirect)
	}

	return (
		<li className="profile-nav onhover-dropdown pe-0 py-0">
			<div className="media profile-media">
				<Image
					attrImage={{
						className: 'b-r-10 m-0',
						src: `${authenticated && auth0_profile ? auth0_profile.picture : profile}`,
						alt: ''
					}}
				/>
				<div className="media-body">
					<span>{user ? `${user.name} ${user.surname}` : authenticated && auth0_profile ? auth0_profile.name : 'User'}</span>
					<P attrPara={{ className: 'mb-0 font-roboto' }}>
						{user ? user.role : Admin} <i className="middle fa fa-angle-down"></i>
					</P>
				</div>
			</div>
			<UL attrUL={{ className: 'simple-list profile-dropdown onhover-show-div' }}>
				<LI
					attrLI={{
						onClick: () => UserMenuRedirect(`${process.env.PUBLIC_URL}/profile/${layoutURL}`)
					}}
				>
					<User />
					<span>{Account} </span>
				</LI>

				<LI attrLI={{ onClick: Logout }}>
					<LogIn />
					<span>{LogOut}</span>
				</LI>
			</UL>
		</li>
	)
}

export default UserHeader
